import { render, staticRenderFns } from "./create4agiso.vue?vue&type=template&id=075300da&scoped=true"
import script from "./create4agiso.vue?vue&type=script&lang=js"
export * from "./create4agiso.vue?vue&type=script&lang=js"
import style0 from "./create4agiso.vue?vue&type=style&index=0&id=075300da&prod&lang=less&scoped=true"
import style1 from "./create4agiso.vue?vue&type=style&index=1&id=075300da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075300da",
  null
  
)

export default component.exports